var map = {
	"./1voucher-light.svg": "4917",
	"./1voucher.svg": "d724",
	"./Shape.svg": "ef79",
	"./account-light.svg": "9596",
	"./account-number-light.svg": "fec8",
	"./account-number.svg": "ae74",
	"./account.svg": "ecec",
	"./active-enaira-option.svg": "c75b",
	"./afrigo.svg": "eb81",
	"./amex.svg": "485e",
	"./app_assets_img_mastercard.svg": "b528",
	"./apple-pay-logo-lg.svg": "9392",
	"./apple-pay-logo-sm.svg": "408c",
	"./applepay-light.svg": "5960",
	"./applepay.svg": "5173",
	"./bank-building-light.svg": "610a",
	"./bank-building.svg": "f8c2",
	"./bank-light.svg": "6c51",
	"./bank.svg": "02f2",
	"./banktransfer-light.svg": "e8ea",
	"./banktransfer.svg": "18df",
	"./barter-light.svg": "5124",
	"./barter.svg": "d7d9",
	"./black-tick.svg": "9521",
	"./building-light.svg": "b17b",
	"./building.svg": "a528",
	"./capitec-light.svg": "064d",
	"./capitec.svg": "b1d8",
	"./card-afrigo.svg": "edd8",
	"./card-amex.svg": "d92e",
	"./card-dinersclub.svg": "2896",
	"./card-discover.svg": "18a1",
	"./card-expiry-date.svg": "7398",
	"./card-light.svg": "c8ca",
	"./card-mastercard.svg": "ddcf",
	"./card-number-input-light.svg": "e3ac",
	"./card-number-input.svg": "1e17",
	"./card-verve.svg": "86da",
	"./card-visa.svg": "1a3f",
	"./card.svg": "5d4a",
	"./cashback-icon.svg": "9bf7",
	"./change-payment.svg": "2701",
	"./close-mini.svg": "05d6",
	"./close.svg": "8b1b",
	"./copy.svg": "8aac",
	"./credit-card-light.svg": "151d",
	"./credit-card.svg": "98dc",
	"./cryptocurrency-light.svg": "72fd",
	"./cryptocurrency.svg": "8372",
	"./cvv-info-en.svg": "53198",
	"./cvv-info-fr.svg": "0c88",
	"./cvv-light.svg": "c315",
	"./cvv.svg": "2094",
	"./dinersclub.svg": "599f",
	"./discover.svg": "b150",
	"./email-light.svg": "4f01",
	"./email.svg": "43be",
	"./enaira-light.svg": "d946",
	"./enaira.svg": "821f",
	"./fawrypay-light.svg": "b5fc",
	"./fawrypay.svg": "dd64",
	"./globe-light.svg": "25a0",
	"./globe.svg": "0de3",
	"./go-back.svg": "b33c",
	"./google-btn.svg": "a3ec",
	"./google-pay-logo-lg.svg": "6504",
	"./google-pay-logo-sm.svg": "dc74",
	"./googlepay-light.svg": "7d45",
	"./googlepay.svg": "b1bf",
	"./inactive-enaira-option.svg": "a4ce",
	"./info-icon.svg": "2656",
	"./info-light.svg": "0149",
	"./internetbanking-light.svg": "1a05",
	"./internetbanking.svg": "8f5a",
	"./language.svg": "a25c",
	"./list-item.svg": "0821",
	"./location-light.svg": "a234",
	"./location.svg": "d2eb",
	"./lock-icon-light.svg": "dc62",
	"./lock-icon.svg": "47d9",
	"./mastercard.svg": "8302",
	"./migo-light.svg": "ea79",
	"./migo.svg": "1e60",
	"./mobilemoney-light.svg": "887e",
	"./mobilemoney.svg": "d0af",
	"./new-visa.svg": "1467",
	"./nqr-light.svg": "5f81",
	"./nqr.svg": "8944",
	"./null.svg": "9155",
	"./opay-light.svg": "d241",
	"./opay.svg": "fda7",
	"./othercard.svg": "60e5",
	"./paga-light.svg": "0e86",
	"./paga.svg": "16bc",
	"./password-light.svg": "eb14",
	"./password.svg": "b009",
	"./payattitude-light.svg": "6e1b",
	"./payattitude.svg": "c141",
	"./paypal-light.svg": "9576",
	"./paypal.svg": "8a1b",
	"./plain.svg": "e03b",
	"./promo.svg": "ddef",
	"./qr-light.svg": "ce69",
	"./qr.svg": "47e3",
	"./redirect.svg": "420c",
	"./smart-phone-light.svg": "cdb1",
	"./smart-phone.svg": "1902",
	"./state-light.svg": "24e5",
	"./state.svg": "de51",
	"./success_mark.svg": "3ef0",
	"./timer-icon.svg": "77f7",
	"./timer.svg": "291e",
	"./user-light.svg": "233e",
	"./user.svg": "6aed",
	"./ussd-light.svg": "3cc7",
	"./ussd.svg": "31c4",
	"./verve.svg": "8d53",
	"./visa-logo.svg": "c3db",
	"./visa.svg": "30e2",
	"./wechat-light.svg": "be25",
	"./wechat.svg": "95d6",
	"./zip-code-light.svg": "5c0b",
	"./zip-code.svg": "b726"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";